export default __webpack_public_path__ + "static/media/Fractalus.c79aaf64.jpg";